// import firebase from '@/scripts/firebase';
import data from '../assets/data/data.json';

export default {
  LOAD_FIREBASE_PAGE: async (context, payload) => {
    // Check if we already have the page content
    // otherwise load it from firebase
    let content = context.state.pages[payload.city][payload.page];

    if (typeof content === 'undefined') {
      content = data.content.pages[payload.city].childrens[payload.page]
        ? data.content.pages[payload.city].childrens[payload.page].structure.en
        : data.content.pages[payload.city].structure.en;
      context.commit('STORE_FIREBASE_PAGE', { ...payload, content });
    }

    return content;
  },

  LOAD_FIREBASE_COMPONENTS: async (context, payload) => {
    let components = context.state.components;

    if (Object.keys(components).length <= 0) {
      components = data.settings.components;
      context.commit('STORE_FIREBASE_COMPONENTS', { components });
    }

    return data;
  },

  LOAD_SINGLE_SPEAKER: async (context, payload) => {
    let speaker = context.state.speakers[payload.city][payload.id];

    if (typeof speaker === 'undefined') {
      console.log(data.settings.extra.speakers.content[payload.city][payload.id]);
      speaker = data.settings.extra.speakers.content[payload.city][payload.id];
      context.commit('STORE_SINGLE_SPEAKER', { city: payload.city, key: payload.id, data: speaker });
    }

    return speaker;
  },

  LOAD_ALL_SPEAKERS: async (context, payload) => {
    // Wont' look at cache and will focely reload all speakers
    // let speakers = context.state.speakers[payload.city];

    // if (Object.keys(speakers).length ===  0) {
    // }
    const speakers = data.settings.extra.speakers.content[payload.city];
    context.commit('STORE_ALL_SPEAKERS', { city: payload.city, data: speakers });

    return speakers;
  },

  LOAD_ALL_MEDIA: async (context) => {
    // const media = await firebase.loadAllMedia();
    context.commit('STORE_ALL_MEDIA', data.content.media);
  }
};
